import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { assignUsersListAction } from '@/redux/actions/employee';
import { assignUsersList, TAssignUsersListResponse } from '@/services/api/employee';
import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* assignUsersListSaga(action: ActionType<typeof assignUsersListAction.request>): Generator {
  const { materials, companyId, projectId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(assignUsersList, materials, companyId, projectId);
    const assignUsersListResponse: TAssignUsersListResponse = response as TAssignUsersListResponse;
    yield put(assignUsersListAction.success(assignUsersListResponse));
    successCallback?.(assignUsersListResponse);
  } catch (err) {
    yield put(assignUsersListAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.assignEmployeesListError');
  }
}
